import { AfterViewInit, Component, inject, input, model, OnInit, signal, ViewChild } from '@angular/core';
import { DatePipe, AsyncPipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subject, map, shareReplay, takeUntil } from 'rxjs';

// translation service
import { TranslatePipe } from '@ngx-translate/core'; 

import { TableColumn } from '../../services/common-service';

// Angular Material
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';


@Component({
  selector: 'app-datatable-component',
  imports: [
    DatePipe,
    AsyncPipe,
    CurrencyPipe,
    DecimalPipe,
    RouterLink,
    TranslatePipe,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    MatCheckboxModule,
  ],
  templateUrl: './datatable-component.html',
  styleUrl: './datatable-component.css'
})
export class DatatableComponent implements OnInit, AfterViewInit {
  constructor(

  ) { }

  private breakpointObserver = inject( BreakpointObserver );
  private destroy$ = new Subject<void>();
  selection = new SelectionModel<any>( true, [] );



  isHandset$: Observable<boolean> = this.breakpointObserver.observe( Breakpoints.Handset )
    .pipe(
      map( result => result.matches ),
      shareReplay( { refCount: true, bufferSize: 1 } ),
      takeUntil( this.destroy$ )
    );

 
  data = model<any[]>([]);
  columns = input<TableColumn[]>( [] );
  readOnly = input<boolean>( false );
  dataSource = new MatTableDataSource<any>();  
  displayedColumns: string[] = [];
  loading = signal( true );  
 
  public pageIndex = 0;
  public pageSize = 10;
  public pageSizeOptions = [10, 20, 50, 100];

  ngOnInit(): void
  {
    // Initialize with empty data or fetch initial data here
    this.selection.clear();
    this.dataSource.data = this.data();
    this.displayedColumns = this.columns().filter( c => !!c.field ).map( c => c.field! );
  }  

  ngOnDestroy(): void
  {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @ViewChild( MatPaginator ) paginator!: MatPaginator;
  @ViewChild( MatSort ) sort!: MatSort;

  ngAfterViewInit()
  {
    this.loading.set( false );
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;   
  }

  applyFilter( event: Event )
  {
    const filterValue = ( event.target as HTMLInputElement ).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    
    if ( this.dataSource.paginator )
    {
      this.dataSource.paginator.firstPage();
    }
  }
  
  isAllSelected()
  {
    return (this.selection.selected.length === this.dataSource.data.length);
  }
  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows()
  {
    if ( !this.selection.isEmpty() )
    {
      this.selection.clear();
      return;
    }
    this.selection.select( ...this.dataSource.filteredData );
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel( row?: any ): string
  {
    if ( !row )
    {
      return `${!this.selection.isEmpty() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected( row ) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  updateValue( row: any, field: string, event: any )
  {
    var value = ( event.target as HTMLInputElement ).value; 
    row[field] = value;    
  }

  getTotal( field: string ): number
  {
    //this.dataSource.data.reduce( ( acc, item ) => acc + ( item[field] || 0 ), 0 );
    const total = this.selection.selected.reduce( ( acc, item ) => acc + ( parseFloat(item[field]) || 0 ), 0 );
    return total;
  }

  getCount(): number
  {
    return this.selection.selected.length;
  }

  getAverage( field: string ): number
  {
    const count = this.getCount();
    if ( count === 0 )
    {
      return 0;
    }
    const total = this.getTotal( field );
    return total / count;
  }


}
